import { render, staticRenderFns } from "./ToneParagraphsSection.vue?vue&type=template&id=745117b3"
import script from "./ToneParagraphsSection.vue?vue&type=script&lang=ts"
export * from "./ToneParagraphsSection.vue?vue&type=script&lang=ts"
import style0 from "./ToneParagraphsSection.vue?vue&type=style&index=0&id=745117b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports